import { io } from 'socket.io-client';

const getAuthToken = () => localStorage.getItem('accessToken');

const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_URL || 'wss://api.cliclaim.com';

export const collabSocket = io(`${SOCKET_BASE_URL}/collaboration`, {
  autoConnect: false,
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  auth: (cb) => {
    cb({ token: getAuthToken() });
  }
});
